import Api from 'services';

export const rhHasErrored = () => ({type: '[RH] HAS_ERRORED'});
export const rhIsLoading = () => ({type: '[RH] IS_LOADING'});
export const rhFetchSuccess = data => ({type: '[RH] FETCH_SUCCESS', data});


// ACTION CREATORS

export const rh_get_rows = (filial) => async dispatch => {
    dispatch(rhIsLoading());
    Api.Rh.getRows(filial)
        .then(data => dispatch(rhFetchSuccess(data)))
        .catch(() => dispatch(rhHasErrored()));
};

export const get_all_filial = () => async dispatch => {
    dispatch(rhIsLoading());
    Api.Rh.getFilial()
        .then(data => dispatch(rhFetchSuccess(data)))
        .catch(() => dispatch(rhHasErrored()));
};


export const get_all_stores_user = () => async dispatch => {
    dispatch(rhIsLoading());
    Api.Rh.getUsersStore()
        .then(data => dispatch(rhFetchSuccess(data)))
        .catch(() => dispatch(rhHasErrored()));
};


export const set_rh = (valor) => async dispatch => {
    dispatch(rhIsLoading());
    await Api.Rh.setRh(valor)
        .then(data => dispatch(rhFetchSuccess(data)))
        .catch(() => dispatch(rhHasErrored()));
};


export const set_comment = (comment) => async dispatch => {
    dispatch(rhIsLoading());
    await Api.Rh.setComment(comment)
        .then(data => dispatch(rhFetchSuccess(data)))
        .catch(() => dispatch(rhHasErrored()));
};
